import {
  Box,
  CardMedia,
  Paper,
  Typography,
  TypographyProps,
} from '@mui/material';
import { styled } from '@mui/material/styles';

export const CardContainer = styled(Paper)(({ theme }) => ({
  borderRadius: '10px',
  margin: '8px 0 16px',
  padding: '16px',
  border: '1.5px solid',
  overflow: 'hidden',
  minWidth: 0,
  overflowWrap: 'anywhere',
  [theme.breakpoints.up('xxxl')]: {
    borderRadius: '20px',
  },
  position: 'relative',
}));

export const TypeFlag = styled(Box)(({ theme }) => ({
  width: '50px',
  height: '42px',
  float: 'right',
  margin: '-17.5px -17px 0',
  clipPath: 'polygon(100% 0, 0 0, 100% 100%)',
  borderTopRightRadius: '9px',
  [theme.breakpoints.up('xxxl')]: {
    width: '100px',
    height: '84px',
  },
}));

interface CardLabelProps extends TypographyProps {
  late?: boolean;
}

/**
 * One "label: value" row. Label and value share a single line; a value that
 * does not fit is clipped with an ellipsis so the card keeps a stable height.
 */
export const CardLabel = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'late',
})<CardLabelProps>(({ theme, late }) => ({
  display: 'flex',
  alignItems: 'baseline',
  gap: '8px',
  minWidth: 0,
  fontSize: '14px',
  fontWeight: '600',
  color: '#1A1A1A',
  textAlign: 'start',
  whiteSpace: 'nowrap',
  '& > span': {
    flex: 1,
    minWidth: 0,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  ...(late && {
    color: '#a60e0e',
  }),
  [theme.breakpoints.up('xxxl')]: {
    fontSize: '32px',
  },
}));

type SlaLabelProps = {
  color?: string;
};
export const SlaLabel = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'color',
})<SlaLabelProps>(({ color }) => ({
  fontSize: 13,
  fontWeight: '600',
  color: color ?? '#1A1A1A',
  marginTop: 4,
  display: 'flex',
  gap: 4,
  alignItems: 'center',
  span: {
    fontSize: 20,
  },
}));

export const info = {
  fontWeight: '400',
  fontSize: '13px',
};

export const AvmStatusBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  position: 'absolute',
  alignItems: 'center',
  flexDirection: 'column',
  right: 5,
  bottom: 5,
  gap: 4,
  color: theme.palette.common.grey,
  p: {
    fontSize: 10,
    margin: 0,
    visibility: 'hidden',
  },
  ':hover': {
    p: {
      visibility: 'visible',
    },
  },
}));

export const ProtoIcon = styled(CardMedia)(() => ({
  width: '30px',
  height: '30px',
}));

/** Queue distribution state of the card (REAL-3271): icon + short label. */
export const DistributionLine = styled(Box)(({ theme }) => ({
  ...theme.typography.body2,
  display: 'flex',
  alignItems: 'center',
  gap: theme.palette.tokens.space[1],
  marginTop: theme.palette.tokens.space[1],
  fontWeight: theme.palette.tokens.font.weightMedium,
  color: theme.palette.text.primary,
  '& .material-symbols-outlined': {
    fontSize: '20px',
  },
}));

export const RejectedIcon = styled(Box)(() => ({
  position: 'absolute',
  bottom: 0,
  right: 6,
  span: {
    color: '#FF334B',
  },
}));
